<script setup lang="ts">
import { faSearch } from '@fortawesome/pro-duotone-svg-icons'
import { faBars } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  showSearch: boolean
}>()

const leftNavItems = useLeftNavItems()

const rightNavItems = useRightNavItems()

// The marketing bar has fewer labels and no search, so it collapses later
const collapse = getNavigationContext() === 'marketing'
  ? { links: 'hidden xl:block', toggle: 'xl:hidden' }
  : { links: 'hidden topbar-full:block', toggle: 'topbar-full:hidden' }

const open = defineModel('open', {
  default: false,
})

const openSearch = defineModel('openSearch', {
  default: false,
})
</script>

<template>
  <div class="relative flex items-center gap-x-m full-width">
    <NavLogo />
    <nav aria-label="Hovedmeny" class="flex-1 items-center flex justify-end">
      <ul class="pendo-menu flex items-center gap-3xs" :class="{ '2xl:flex-1': leftNavItems.length > 0 }">
        <NavItem
          v-for="(item, index) in leftNavItems"
          :key="item.label"
          :item="item"
          class="pendo-menu-left shrink-0"
          :class="[collapse.links, { '2xl:me-auto': index === leftNavItems.length - 1 }]"
        />

        <li v-if="showSearch" class="pendo-menu-right">
          <NavToggle v-model="openSearch" data-search-toggle name="Søk" :icon="faSearch" />
        </li>
        <NavItem v-for="item in rightNavItems" :key="item.label" :item="item" class="pendo-menu-right shrink-0 hidden topbar:block" />
        <li class="pendo-menu-right" :class="collapse.toggle">
          <NavToggle v-model="open" name="Meny" :icon="faBars" />
        </li>
      </ul>
    </nav>
  </div>
</template>
